export const buscaSecoesPorGenero = (api, props, controller) => {
  return api.get(`secoes_categoria`, {
    signal: controller.signal,
    params: props,
  });
};

//secoes_categoria/{secaoId}/categorias
export const buscaCategoriaPergunta = (api, props, controller) => {
  const { secao_categoria_id } = props;

  return api.get(`secoes_categoria/${secao_categoria_id}/categorias`, {
    signal: controller.signal,
    params: props,
  });
};